function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actions as ppcActions } from '../../reducers/ppc.reducer';
import Card from '../common/card/Card.react';
import CardHeader from '../common/card/CardHeader.react';
import CardBody from '../common/card/CardBody.react';
import Button from '../common/Button.react';
import BtnArrow from '../common/BtnArrow.react';
import AzureBlob from '../common/AzureBlob.react';
import Checkbox from '../common/form/Checkbox.react';
import SlideBG from './SlideBG.react';
import SlideText from './SlideText.react';
import SlideButton from './SlideButton.react';
var Slide = function Slide(_ref) {
  var slide = _ref.slide;
  var dispatch = useDispatch();
  var bucket = useSelector(function (s) {
    return s.config.bucket;
  });
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    state = _useState2[0],
    setState = _useState2[1];
  useEffect(function () {
    setState(slide);
  }, [slide]);
  var slideID = state._id,
    logo = state.logo,
    image = state.image,
    line1 = state.line1,
    line2 = state.line2,
    line3 = state.line3,
    line4 = state.line4,
    button = state.button;
  var handleOnChange = function handleOnChange(formData) {
    dispatch({
      type: ppcActions.construxHomeSlider,
      payload: {
        formData: _objectSpread(_objectSpread({}, formData), {}, {
          slideID: slideID,
          apiID: 'slide-update'
        }),
        method: 'put'
      }
    });
  };
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Landingpage Slider",
    button: {
      label: 'Delete',
      type: 'delete',
      requireConfirmation: true,
      // permission: 'edit-pos-sections',
      onClick: function onClick() {
        dispatch({
          type: ppcActions.construxHomeSlider,
          payload: {
            formData: {
              slideID: slideID
            },
            method: 'delete'
          }
        });
      }
    }
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    className: "slide"
  }, /*#__PURE__*/React.createElement("div", {
    className: "slide__preview"
    // style={{
    // 	backgroundImage: image?.filename ? `url(${bucket}/${image.filename})` : '',
    // }}
  }, (image === null || image === void 0 ? void 0 : image.filename) && /*#__PURE__*/React.createElement(AzureBlob, {
    filename: image.filename,
    assetID: image.asset,
    className: "slide__bg"
  }), (logo === null || logo === void 0 ? void 0 : logo.isVisible) && /*#__PURE__*/React.createElement("img", {
    src: "/public/images/construx-slider-logo.png",
    className: "slide__preview--logo"
  }), /*#__PURE__*/React.createElement("div", {
    className: "slide__heading"
  }, (line1 === null || line1 === void 0 ? void 0 : line1.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "slide__heading--line1"
  }, line1), (line2 === null || line2 === void 0 ? void 0 : line2.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "slide__heading--line2"
  }, line2), (line3 === null || line3 === void 0 ? void 0 : line3.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "slide__heading--line3"
  }, line3), (line4 === null || line4 === void 0 ? void 0 : line4.length) > 0 && /*#__PURE__*/React.createElement("div", {
    className: "slide__heading--line4"
  }, line4), (button === null || button === void 0 ? void 0 : button.isVisible) && /*#__PURE__*/React.createElement(BtnArrow, {
    label: button.label,
    style: {
      marginTop: 40
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "slide__settings"
  }, /*#__PURE__*/React.createElement(SlideBG, state), /*#__PURE__*/React.createElement(SlideText, _extends({}, state, {
    onChange: function onChange(key, val) {
      setState(_objectSpread(_objectSpread({}, state), {}, _defineProperty({}, key, val)));
    }
  })), /*#__PURE__*/React.createElement("h3", {
    style: {
      marginTop: 20
    }
  }, "Settings"), /*#__PURE__*/React.createElement(Checkbox, {
    checked: logo === null || logo === void 0 ? void 0 : logo.isVisible,
    label: "Show Logo",
    onChange: function onChange(val) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        logo: {
          isVisible: val
        }
      }));
    }
  }), /*#__PURE__*/React.createElement(SlideButton, _extends({}, state, {
    onChange: function onChange(key, val) {
      setState(_objectSpread(_objectSpread({}, state), {}, {
        button: _objectSpread(_objectSpread({}, state.button), {}, _defineProperty({}, key, val))
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "slide__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Save",
    onClick: function onClick() {
      dispatch({
        type: ppcActions.construxHomeSlider,
        payload: {
          formData: {
            slideID: slideID,
            button: button,
            line1: line1,
            line2: line2,
            line3: line3,
            line4: line4,
            logo: logo
          },
          method: 'put',
          route: 'details'
        }
      });
    }
  }))))));
};
export default Slide;